const getShortLocale = (locale?: string) => {
  const [shortLocale] = locale ? locale.split('-') : ['en'];
  return shortLocale;
};

export default getShortLocale;
